module.exports = __webpack_public_path__ + "static/Carnaval-2700678f55dfbbdd2509099778016f5d.jpg";